import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import MainTitle from "components/MainTitle";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate ****************************/}
        <QuickDonate />

        {/* quick donate popup  *********************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  ********************/}
        <MainTitle title={t("Privacy Policy")} />

        {/* the content  ****************************/}
        <section className="my-[100px]">
          <div className="mainContainer w-full px-[40px] lg:px-0 flex flex-col gap-[20px]">
            {/* part  */}
            <div>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Al-Etihad Charity Foundation is committed to protecting the rights of all visitors to its electronic application in terms of maintaining the confidentiality of sensitive information. This privacy policy explains how the Foundation deals with the personal information of users,including"
                )}
              </p>
            </div>

            {/* First  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("First: Information Security:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The website for Al-Etihad Charity Foundation has security measures to protect the information that is provided in the website."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Al-Etihad Charity Foundation encrypts the information that is considered sensitive (such as credit card numbers) or data that must be kept confidential in line with legal requirements.."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The website of Al-Etihad Charity Foundation applies appropriate security measures to protect information from loss, misuse, or alteration. These procedures cover commercial software and secured technical infrastructure to monitor network traffic, allow the entry of registered users and identify illegal attempts to download, change or cause information in addition, all employees of the institution follow a comprehensive security policy to ensure that its employees undertake to secure the confidentiality of customer information..."
                )}
              </p>
            </div>

            {/* Second  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Second: Registration:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Some pages of the website are only open to registered members or allow the user to request electronic support by entering personal information such as name and email."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "In the event that any information provided through these pages is an agreement to the privacy policy and that it is complete and accurate information, and that no registration or attempt to enter the application will be made using the name of another person, and a user name that the institution may deem inappropriate will not be adopted."
                )}
              </p>
            </div>

            {/* Third  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Third: Approval to collect and use information:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "When entering the website of Al-Etihad Charity Foundation, you agree to the following:"
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Al-Etihad Charity Foundation collects personal information such as name, address, email,and mobile phone number when the user provides it - with full awareness and knowledge."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The institution may collect any other information provided by users such as an address,date of birth, etc., which can identify personal identification."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The organization's web provider software automatically collects statistical information related to users' visits, such as the pages they visit, the date and time of the website visit,and the type of device and the browser used to visit the website."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The Website automatically captures your Internet Protocol address (the number of the computer you are using), and the Internet protocol is used to conduct the necessary statistics to measure the use of the site and help diagnose technical problems that may occur on the website of the institution."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The Foundation is committed not to allowing anyone outside the framework of its technical team to view your Internet Protocol, and this data is not collected for commercial or marketing purposes, and Al-Etihad Charity Foundation does not sell, exchange, or distribute in any other way the collected data for any commercial or marketing purposes."
                )}
              </p>
            </div>

            {/* Fourth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Fourth: Protection of Personal Information:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Your personal information will only be available to the employees of the institution who need to view that information."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "This information will not be available to the public without your consent."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "None of this information will be exchanged, traded, or sold to any third party without your prior consent."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Access to information will only be allowed to those qualified professionals who provide the services of Al-Etihad Charity Foundation consistent with your interactions with our website."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The institution may use the data recorded on the website to make questionnaires and take opinions with the aim of developing the website and providing a more intuitive and effective experience for visitors and valued users."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "We can communicate with you when needed in case you wish to donate to projects and charitable works or you wish to see the latest projects and charitable works carried out by the Foundation, as this data helps us in communicating with you, answering your inquiries,and implementing your requests as much as possible."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The Corporation does not share this data with external parties unless these parties are needed in the process of completing your request, unless it is in the context of collective data used for statistical purposes and research, without including any data that can be used to identify you."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "In normal cases, the data is dealt with automatically (electronic) through the applications and programs specified for that, without this entailing the participation of the employees or informing them of such data."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "In exceptional cases (such as investigations and cases), the employees of the regulatory authorities, or those who need to be informed of this, maybe informed of them, subject to the provisions of the law and the orders of the regulatory and judicial authorities."
                )}
              </p>
            </div>

            {/* Fifth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Fifth: External links:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The website of Al-Etihad Charity Foundation contains links to other websites whose protection and privacy standards may differ from the standards it adopts. The website of the Foundation is not responsible for any content on those websites and the privacy olicies of these websites, which requires you to read the privacy policy related to those websites."
                )}
              </p>
            </div>

            {/* Sixth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Sixth: Web Browser Cookies Components:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Our site may use browser cookies to improve the service provided to users, and users'web browser places cookies on their hard drive for the purposes of maintaining registration and in some cases obtaining information about them."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Users may choose to modify their web browser to refuse browser cookies, or to notify them when cookies are being sent to it and if they choose to do so, please note that some parts may not function properly."
                )}
              </p>
            </div>

            {/* Seventh  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t(
                  "Seventh: The Right to Inspect, Amend, or Correct Personal Data:"
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Any user who provides us with his personal information has the right to inspect, amend or correct his personal information."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "You can request to amend your personal information by sending an email to"
                )}{" "}
                <a
                  className="hover:text-first_color duration-300 underline"
                  href="mailto:info@etihadcharity.ae"
                >
                  info@etihadcharity.ae
                </a>
              </p>
            </div>

            {/* Eighth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Eighth: Termination and prohibition of use:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Al-Etihad Charity Foundation has the right to terminate, ban or suspend access to or use of the application without prior notice, due to a violation of these terms or laws in force in the United Arab Emirates, or because of any behavior that the Foundation may consider to be in violation of international agreements and norms, or harmful to others, In the event of termination, you will not be able to access the application, and the institution will use all available methods to implement this ban."
                )}
              </p>
            </div>

            {/* Ninth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Ninth: Changes to the Privacy Policy:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The website of Al-Etihad Charity Foundation reserves the right to make any amendment to the terms of the privacy policy from time to time without the need to submit a notification thereof. If you wish to continue using our website after making changes to this Privacy Policy, this means that you accept those changes."
                )}
              </p>
            </div>

            {/* Tenth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Tenth: Contact us:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Please contact us by e-mail: for any inquiries regarding the privacy policy at"
                )}{" "}
                <a
                  className="hover:text-first_color duration-300 underline"
                  href="mailto:info@etihadcharity.ae"
                >
                  info@etihadcharity.ae
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
